import useSWR from 'swr';

import { fetchEndpointData } from '@/utils/fetch.client';

export interface GitHubStatus {
  connected: boolean;
  tokenValid: boolean | null;
  githubUsername: string | null;
  githubEmail: string | null;
  checkError: string | null;
  installationUrl: string | null;
  installNewUrl: string | null;
}

export function useGitHubStatus(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR(
    enabled ? '/api/v1/integrations/github/status' : null,
    () => fetchEndpointData<GitHubStatus>('/api/v1/integrations/github/status'),
    { revalidateOnFocus: false },
  );
  return { status: data ?? null, error, isLoading, mutate };
}
